import { TFunction } from 'i18next'

import { AppError } from '../common/AppError'
import { ErrorMessage } from '../common/ErrorBox'

const errorHeaders: Map<number, string> = new Map([
  [1, 'Resource not found'],
  [100, 'QRCodeUnknownError'],
  [101, 'QRCodeDeserialization'],
  [102, 'QRCodeInvalidImage'],
  [103, 'QRCodeNoPayload'],
  [104, 'QRCodeInvalid'],
  [105, 'QRCodeInvalidKeyIdHash'],
  [106, 'QRCodeTampered'],
  [107, 'QRCodeTamperedOrInvalidPassPhrase'],
  [200, 'OneTimeKeyError'],
  [201, 'OneTimeKeyNoUserGroups'],
  [203, 'OneTimeKeyInvalidUserGroup'],
  [204, 'OneTimeKeyQRFileDoesNotExist'],
  [205, 'OneTimeKeyInvalidQRFile'],
  [206, 'OneTimeKeyInvalidQRpayload'],
  [300, 'AzureADUnknownError'],
  [301, 'AzureADInvalidDomain'],
  [302, 'AzureADAccessToken'],
  [303, 'AzureADUserProfile'],
  [304, 'AzureADUserPrincipalMismatch'],
  [305, 'AzureADUserInvalidUserGroup'],
  [401, 'KmsUnauthorized'],
  [402, 'KmsKeyDoesNotExist'],
  [403, 'KmsKeyDoesNotExistInTableStorage'],
  [404, 'KmsUploadKeyErrorInKeyVault'],
  [405, 'KmsUploadKeyUnauthorized'],
  [406, 'KmsInvalidAzureADLogin'],
  [407, 'KmsNoUserGroups'],
  [408, 'KmsInvalidUserGroup'],
  [409, 'KmsInvalidAccessToken'],
  [410, 'KmsAccessTokenExpired'],
  [411, 'KmsAccessTokenInvalidTenantId'],
  [412, 'KmsAccessTokenTenantIdMismatch'],
  [413, 'KmsInvalidKeyId'],
  [414, 'KmsDeleteKeyUnauthorized'],
  [415, 'KmsKeyVaultSoftDeleteUnrecoverableState'],
  [416, 'KmsInvalidGetKeysRequest'],
  [417, 'KmsGetKeysUnauthorized'],
  [418, 'KmsInvalidRequestPayload'],
  [419, 'KmsRequestRequired'],
  [420, 'KmsKeyNotConcurrent'],
  [430, 'KmsAddKeyMappingsUnauthorized'],
  [431, 'KmsAddKeyMappingsInvalid'],
  [432, 'KmsDeleteKeyMappingsUnauthorized'],
  [433, 'KmsDeleteKeyMappingsInvalid'],
  [434, 'KmsGetKeyMappingsUnauthorized'],
  [435, 'KmsGetKeyMappingsInvalid'],
  [436, 'KmsUpdateKeyMappingsUnauthorized'],
  [437, 'KmsUpdateKeyMappingsInvalid'],
  [438, 'KmsIncorrectContentType'],
  [439, 'KmsUpdateKeyMappingsInvalid'],
  [501, 'KmsAddSigningKeyInvalid'],
  [502, 'KmsGetSigningKeyInvalid'],
  [503, 'KmsDeleteSigningKeyInvalid'],
  [504, 'KmsUpdateSigningKeyInvalid'],
  [601, 'KmsGetCommandRequestInvalid'],
  [602, 'KmsGetCommandNoSigningKey'],
  [603, 'KmsCommandsUnauthorized'],
  [604, 'KmsGetCommandSigningCertInvalid'],
  [605, 'KmsGetSigningCertExportableInvalid'],
  [606, 'KmsGetP21SKProvisioningPayloadInvalid'],
])

export function getErrorMessage(
  error: AppError,
  t: TFunction<'translation', undefined>,
): ErrorMessage {
  const errorHeading: string =
    errorHeaders.get(error.errorCode) ||
    errorHeaders.get(100) ||
    t('unlock_pin_page.unknown_error')
  const errorContent: string = error.message || t('unlock_pin_page.error')
  return {
    heading: errorHeading,
    content: errorContent,
  }
}
